(ns bec-core.cljs.routes
  (:require [reagent.core :as r]
            [re-frame.core :as rf]
            [clojure.string :as s]
            [cljs.reader :as reader]
            [lambdaisland.uri :refer [uri query-string->map map->query-string]]
            [bec-cljs-common.utils.formatting :as fmt]))

(defonce history (r/atom nil))
(defonce uri-map (r/atom (uri js/window.location.href)))
(defonce history-navigation-info (r/atom {:current-history-index 0
                                          :history-length 0}))

(def setup
  {:home {:title "Home"
          :view :home}
   :venues {:title "Venues"
            :view :venues}
   :machines {:title "Machines"
              :view :machines}
   :dashboard {:title "Dashboard"
               :view :dashboard}})

(defn path-string->keyword [path]
  (let [split-path (s/split path "/")]
    (if (= (first split-path) "")
      (keyword (second split-path))
      (keyword (first split-path)))))

(defn uri->view-key [& [uri-map-input]]
  (let [uri-map (or uri-map-input (uri js/window.location.href))
        path (fmt/lower-case (:path uri-map))
        search-query-string (:query uri-map)
        query-map (query-string->map search-query-string)
        query-view (fmt/lower-case (:view query-map))
        view-key (or (if (keyword? query-view)
                       query-view
                       (keyword query-view))
                   (path-string->keyword path))]
    view-key))

(defn uri->query-map [& [uri-map-input]]
  (let [search-query-string (:query (or uri-map-input @uri-map (uri js/window.location.href)))
        query-map (query-string->map search-query-string)]
    query-map))

(defn supports-push-state? []
  (and (js-in "history" js/window) (js-in "pushState" js/window.history)))

(defn add-popstate-listener []
  (when (supports-push-state?)
    (reset! history js/window.history)
    
    (js/window.addEventListener "popstate"
      (fn []
        (let [state (reader/read-string js/window.history.state)
              new-uri-map (uri js/window.location.href)]
          (reset! uri-map new-uri-map)
          (if (:view state)
            (rf/dispatch [:select-view (:view state) (merge (:props state) {:push-state? false})])
            (let [view-key (uri->view-key new-uri-map)]
              (when (get setup view-key)
                (rf/dispatch [:select-view view-key {:push-state? false}])))))))))

(defn push-state [view props]
  (when @history
    (let [route-map (get setup view)
          query-map (uri->query-map)
          updated-query-map (assoc query-map 
                              :view (if (keyword? view)
                                      (name view)
                                      view)
                              :sub-view (if (keyword? (:sub-view props))
                                          (name (:sub-view props))
                                          (:sub-view props)))
          new-query-string (map->query-string updated-query-map)
          new-uri-map (assoc @uri-map :query new-query-string)
          current-history-index (:current-history-index @history-navigation-info)
          history-length (:history-length @history-navigation-info)]
      (when route-map
        (reset! uri-map new-uri-map)
        (swap! history-navigation-info assoc 
          :current-history-index (inc current-history-index)
          :history-length (if (> history-length current-history-index)
                            (inc current-history-index)
                            (inc history-length)))
        (.pushState @history
          (pr-str (assoc route-map :props props))
          (:title route-map)
          (str "?" new-query-string))))))

(defn can-go-forward? []
  (< (:current-history-index @history-navigation-info) (:history-length @history-navigation-info)))

(defn can-go-back? []
  (> (:current-history-index @history-navigation-info) 0))

(defn forward []
  (when @history
    (when (can-go-forward?)
     (swap! history-navigation-info assoc 
       :current-history-index (inc (:current-history-index @history-navigation-info))))
    (.forward @history)))

(defn back []
  (when @history
    (when (can-go-back?)
      (swap! history-navigation-info assoc 
        :current-history-index (dec (:current-history-index @history-navigation-info))))
    (.back @history)))